import React from "react";
import { connect } from "react-redux";
import { postParents } from "_constants";
import isEqual from "lodash/isEqual";
import omit from "lodash/omit";
import PropTypes from "prop-types";
import { assetLeadSelector } from "selectors/assetLead";

import { hoverable, ScreenWidth } from "components/hoc";
import { Translate } from "utils";

const { t } = new Translate("Notes");

export default (WrappedComponent) => {
  class EnhancedComponent extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        item: props.item,
        isCollapsed: props.isCollapsed,
        isEdit: !props.item.id || props.isEdit,
      };
      this.initialState = this.state;
      this.handleCancel = this.handleCancel.bind(this);
      this.handleChange = this.handleChange.bind(this);
      this.handleDelete = this.handleDelete.bind(this);
      this.handleEdit = this.handleEdit.bind(this);
      this.handleSave = this.handleSave.bind(this);
    }

    componentWillReceiveProps(nextProps) {
      if (!this.state.isEdit) {
        this.setState({ item: { ...this.state.item, ...nextProps.item } });
      }
    }

    shouldComponentUpdate(nextProps, nextState) {
      return !(
        this.state.isEdit &&
        isEqual(omit(nextProps, ["isHovered"]), omit(this.props, ["isHovered"])) &&
        isEqual(nextState, this.state)
      );
    }

    handleChange(attr, val) {
      this.setState({ item: { ...this.state.item, [attr]: val } });
    }

    handleCancel() {
      this.setState({ ...this.initialState });
      if (this.props.onCancel) this.props.onCancel();
    }

    handleDelete() {
      // eslint-disable-next-line
      if (confirm(t("confirm.delete"))) {
        this.props.onDelete(this.props.item.id);
      }
    }

    // eslint-disable-next-line
    handleDownloadFile(url) {
      return window.open(url, "_blank");
    }

    handleEdit() {
      this.setState({ isCollapsed: false, isEdit: true });
    }

    handleSave(post) {
      if (!this.props.onSave) return;

      const newState = {
        isEdit: !post.id,
        isCollapsed: !post.id,
        item: post.id ? post : { type: "Note", body: "" },
      };
      this.setState({ ...newState });
      this.initialState = newState;
      this.props.onSave({ ...post, parent: this.props.parent });
    }

    render() {
      return (
        <WrappedComponent
          {...{ ...this.props, ...this.state }}
          onCancel={this.handleCancel}
          onChange={this.handleChange}
          onDelete={this.handleDelete}
          onDownloadFile={this.handleDownloadFile}
          onEdit={this.handleEdit}
          onSave={this.handleSave}
        />
      );
    }
  }

  EnhancedComponent.propTypes = {
    item: PropTypes.shape({
      id: PropTypes.number,
      body: PropTypes.string,
    }).isRequired,
    parent: PropTypes.shape({
      id: PropTypes.number,
      type: PropTypes.oneOf(postParents),
    }).isRequired,
    isCollapsed: PropTypes.bool,
    isEdit: PropTypes.bool,
    onCancel: PropTypes.func,
    onDelete: PropTypes.func.isRequired,
    onSave: PropTypes.func,
  };

  const mapStateToProps = (state, ownProps) => {
    const creator = ownProps.item.creator || { id: state.currentUser.id };
    const assetLead = assetLeadSelector(state);

    return {
      item: {
        ...ownProps.item,
        creator,
        emailToken:
          ownProps.parent.type === "Deal"
            ? state.deal.emailToken
            : assetLead && assetLead.emailToken,
      },
      isEditable: creator.id === state.currentUser.id,
    };
  };

  return connect(mapStateToProps)(ScreenWidth(hoverable(EnhancedComponent)));
};
